import { useState } from 'react';
import Card from '../../components/Card';
import AreaChart from '../../components/AreaChart';
import { ValueOf } from '../../config/constants';
import { config } from '../../config/config';
// import useHistoricalTradingVolume from '../../hooks/analytics/useHistoricalTradingVolume';
import useMockHistoricalTradingVolume from '../../hooks/analytics/useMockHistoricalTradingVolume';

const TotalTradingVolume = () => {
    const [timeframeOption, setTimeframeOption] =
        useState<ValueOf<typeof config.areaChartTimeframes>>('1d');
    const [activePayload, setActivePayload] = useState<number | undefined>();

    // const { historicalTradingVolume, defaultData, isLoading } =
    //     useHistoricalTradingVolume(timeframeOption);
    const { historicalTradingVolume, defaultData, isLoading } =
        useMockHistoricalTradingVolume(timeframeOption);

    const handlePayloadChange = (newPayload: number | undefined) => {
        if (newPayload !== activePayload) {
            setActivePayload(newPayload);
        }
    };

    const handleTimeframeChange = (
        newTimeframe: ValueOf<typeof config.areaChartTimeframes>
    ) => {
        setTimeframeOption(newTimeframe);
    };

    return (
        <Card className='large-card'>
            <AreaChart
                isLoading={isLoading}
                data={historicalTradingVolume ?? defaultData}
                withKpi
                activePayload={historicalTradingVolume ? activePayload : undefined}
                onActivePayloadChange={handlePayloadChange}
                label='Total Trading Volume'
                activePayloadLabel='Total Trading Volume'
                withTimeFrames
                timeframes={config.areaChartTimeframes}
                onTimeframeChange={(timeframe) => handleTimeframeChange(timeframe)}
            />
        </Card>
    );
};
export default TotalTradingVolume;
